import React from 'react';
import moment from 'moment';

const ProjectSummary = ({ project }) => {
	const status = project.sign2 ? <div className="teal-text">Status: Signed </div> : <div className="pink-text">Status: Waiting to be signed </div>
    
	return (
		<div className='card project-summary'>
			<div className="card-content grey-text text-darken-3">
				<span className="card-title">{project.title}</span>
				<p>Created by {project.authorFirstName} {project.authorLastName}</p>
				<p>{moment(project.createdAt.toDate()).calendar()}</p>
				{status}
			</div>
		</div>
	)
};

export default ProjectSummary;